// TODO: deprecated — only consumed by the legacy FileModal via APIProviders.
// FileModal is no longer triggered by any call site (replaced by AddImageModal
// / library panel). Safe to delete with FileModal cleanup.
import React from "react";
import PropTypes from "prop-types";
import i18n from "i18next";
import { Button, Row, Col, Container, FormGroup, FormControl } from "react-bootstrap";
import AppModal from "../../../../common/modal/AppModal";
import CodePreview from "./CodePreview";
import Select from "react-select";
import "../../../../nav_bar/global_config/_reactTags.scss";
import Alert from "../../../../common/alert/Alert";
import { extensionHandlers as extensions } from "../../FileHandlers/FileHandlers";
export default class CharactersComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: undefined,
      filter: "",
      extensionFilter: this.props.show,
      keywords: [],
      confirmDelete: false,
      errorDeleteAlert: false,
    };
    this.generatePreview = this.generatePreview.bind(this);
    this.filesAll = [
      {
        id: "file-7416972898256",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek1.png",
        name: "eerkek1.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-94593645836050",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek10.png",
        name: "eerkek10.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-32726187453629",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek11.png",
        name: "eerkek11.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-5608946876112",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek12.png",
        name: "eerkek12.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-99933801427255",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek13.png",
        name: "eerkek13.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-52147435135892",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek14.png",
        name: "eerkek14.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-41236837589363",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek15.png",
        name: "eerkek15.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-3617811815116",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek16.png",
        name: "eerkek16.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-44808161871830",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek17.png",
        name: "eerkek17.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-89818332489493",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek18.png",
        name: "eerkek18.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-80902824414925",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek19.png",
        name: "eerkek19.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-18101088043617",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek2.png",
        name: "eerkek2.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-84072366303756",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek20.png",
        name: "eerkek20.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-45207522848860",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek21.png",
        name: "eerkek21.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-96852896378940",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek22.png",
        name: "eerkek22.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-7468477674067",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek23.png",
        name: "eerkek23.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-12054147785550",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek3.png",
        name: "eerkek3.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-47009916617976",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek4.png",
        name: "eerkek4.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-10916823032760",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek5.png",
        name: "eerkek5.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-35983088160156",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek6.png",
        name: "eerkek6.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-90664697248049",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek7.png",
        name: "eerkek7.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-59496019033711",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek8.png",
        name: "eerkek8.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-40508438775642",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/eerkek9.png",
        name: "eerkek9.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-14649456347208",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/erkek1.png",
        name: "erkek1.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-81639525496736",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/erkek2.png",
        name: "erkek2.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-66861095242280",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/erkek3.png",
        name: "erkek3.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-21433459078649",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/erkek4.png",
        name: "erkek4.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-16281851748880",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/erkek5.png",
        name: "erkek5.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-53085131496882",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/erkek6.png",
        name: "erkek6.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-58115624473143",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/erkek7.png",
        name: "erkek7.png",
        keywords: "erkek,man",
        mimetype: "image/png",
      },
      {
        id: "file-2146563585339",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin1.png",
        name: "kadin1.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-85385667957823",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin10.png",
        name: "kadin10.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-77825261792834",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin11.png",
        name: "kadin11.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-36849843211361",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin12.png",
        name: "kadin12.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-8332940308332",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin13.png",
        name: "kadin13.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-78265842070069",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin14.png",
        name: "kadin14.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-46141862074910",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin15.png",
        name: "kadin15.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-354078501992",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin16.png",
        name: "kadin16.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-25095683339385",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin17.png",
        name: "kadin17.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-3738601944422",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin18.png",
        name: "kadin18.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-13056971140583",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin19.png",
        name: "kadin19.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-61169313853077",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin2.png",
        name: "kadin2.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-19100896164198",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin20.png",
        name: "kadin20.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-22358175107489",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin21.png",
        name: "kadin21.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-97089105280475",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin22.png",
        name: "kadin22.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-29104814632271",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin23.png",
        name: "kadin23.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-68894579973096",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin24.png",
        name: "kadin24.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-17188289961756",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin25.png",
        name: "kadin25.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-91860645332203",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin26.png",
        name: "kadin26.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-94957602907536",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin27.png",
        name: "kadin27.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-88531453294257",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin28.png",
        name: "kadin28.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-83386783664010",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin29.png",
        name: "kadin29.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-94821994081070",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin3.png",
        name: "kadin3.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-94548677701250",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin30.png",
        name: "kadin30.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-99193756564795",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin31.png",
        name: "kadin31.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-4492644610299",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin32.png",
        name: "kadin32.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-62983048947470",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin33.png",
        name: "kadin33.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-85105183832558",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin34.png",
        name: "kadin34.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-34850096780521",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin35.png",
        name: "kadin35.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-72683307693701",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin36.png",
        name: "kadin36.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-6254306140488",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin37.png",
        name: "kadin37.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-85710712519458",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin38.png",
        name: "kadin38.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-97073961422",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin39.png",
        name: "kadin39.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-84779362751117",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin4.png",
        name: "kadin4.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-9777466478355",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin40.png",
        name: "kadin40.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-63944609772247",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin41.png",
        name: "kadin41.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-51834814034832",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin42.png",
        name: "kadin42.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-4749744680413",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin43.png",
        name: "kadin43.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-49791926568453",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin44.png",
        name: "kadin44.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-58623765173016",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin45.png",
        name: "kadin45.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-42406789326570",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin46.png",
        name: "kadin46.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-51970319588840",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin47.png",
        name: "kadin47.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-30462598526124",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin48.png",
        name: "kadin48.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-66579268944621",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin49.png",
        name: "kadin49.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-27089835004768",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin5.png",
        name: "kadin5.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-28743661671843",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin50.png",
        name: "kadin50.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-79322531200644",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin51.png",
        name: "kadin51.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-35063854238345",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin52.png",
        name: "kadin52.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-37073368269656",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin53.png",
        name: "kadin53.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-97970649722110",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin54.png",
        name: "kadin54.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-99559789690080",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin55.png",
        name: "kadin55.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-3454487895631",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin6.png",
        name: "kadin6.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-1078558924387",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin7.png",
        name: "kadin7.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-52270899876957",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin8.png",
        name: "kadin8.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-57837034938960",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kadin9.png",
        name: "kadin9.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-39515142467607",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin1.png",
        name: "kkadin1.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-80765775417522",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin10.png",
        name: "kkadin10.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-27333235197160",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin11.png",
        name: "kkadin11.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-65513943484317",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin12.png",
        name: "kkadin12.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-65775558746916",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin13.png",
        name: "kkadin13.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-74201056509940",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin14.png",
        name: "kkadin14.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-386328576987",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin2.png",
        name: "kkadin2.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-58765378333224",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin3.png",
        name: "kkadin3.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-12008548638232",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin4.png",
        name: "kkadin4.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-70261021366939",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin5.png",
        name: "kkadin5.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-93368985349359",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin6.png",
        name: "kkadin6.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-32043257068763",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin7.png",
        name: "kkadin7.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-19867393894006",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin8.png",
        name: "kkadin8.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
      {
        id: "file-96233105675588",
        url: "https://cloud.aideapro.ai/middlewareblob/common/aideapro/library/KKarakter/kkadin9.png",
        name: "kkadin9.png",
        keywords: "kadın,woman",
        mimetype: "image/png",
      },
    ];

    this.filesAll.sort((a, b) => b.id.localeCompare(a.id));
    this.files = null;
  }
  render() {
    let empty = true;

    this.files = this.filesAll.map((f) => {
      let file = f;
      let type = file.mimetype;
      let icon = "face";
      for (let e in extensions) {
        let ext = extensions[e];

        if (ext.value !== "" && type.match(ext.value)) {
          type = ext.value;
          icon = ext.icon;
        }
      }
      if (
        (file.name && file.keywords.match(this.state.filter)) ||
        (file.mimetype && file.mimetype.match(this.state.filter)) // Matches written filter
        //&& (this.state.extensionFilter === "*" || (file.mimetype && file.mimetype.match(this.state.extensionFilter))) // Matches extension filter
      ) {
        empty = false;
        return { ...file, type, icon };
      }

      return { ...file, type, icon, hide: true };
    });
    // //files.reverse();
    // let currentExtension = this.props.show === "*" ? this.state.extensionFilter : this.props.show;
    // currentExtension = currentExtension === '*' ? '' : currentExtension;
    // let aux = currentExtension;
    // for (let e in extensions) {
    //     let ext = extensions[e];
    //     if (currentExtension.match(ext.value)) {
    //         aux = ext.value;
    //     }
    // }
    // currentExtension = aux;

    //let fileSelected = this.filesAll.find(a=>a.id===this.props.idSelected);
    // let download = { // Forces browser download
    //     title: i18n.t('FileModal.FileHandlers.downloadAsFile'),
    //     disabled: !fileSelected,
    //     action: ()=>{
    //         window.open(fileSelected.url);
    //     },
    // };
    /*  <h5>{this.props.icon ? <img className="fileMenuIcon" src={this.props.icon } alt=""/> : this.props.name}</h5> */
    return (
      <div className="contentComponent CharactersComponent">
        {/* <h5>{i18n.t("FileModal.APIProviders.MyFilesTitle")}</h5>
            <hr /> */}
        <div className={"filters"}>
          <FormGroup key="filter">
            <FormControl
              type="text"
              value={this.state.filter}
              placeholder={i18n.t("Filter")}
              id="filterInput"
              autoFocus
              onChange={(e) => {
                this.setState({ filter: e.target.value });
              }}
            />
          </FormGroup>
          {/* <Col lg={this.props.show !== "*" ? 12 : 8} style={{ padding: "0px" }}>
                    <FormGroup key="filter">
                        <FormControl type="text" value={this.state.filter} placeholder={i18n.t('Filter')} id="filterInput" autoFocus onChange={e => {this.setState({ filter: e.target.value });}}/>
                    </FormGroup>
                </Col>
                <Col lg={this.props.show !== "*" ? 0 : 4} hidden={this.props.show !== "*"} style={{ padding: "0px" }}>
                    <FormGroup key="extfilter">
                        <Select
                            name="form-field-extensions"
                            value={currentExtension}
                            disabled = {this.props.show !== "*"}
                            options={Object.values(extensions)}
                            className="selectD"
                            onChange={e => {this.setState({ extensionFilter: e.value });}} />
                    </FormGroup>
                </Col> */}
        </div>
        <Container>
          <Row
            className="myFilesRow"
            onClick={(e) => {
              this.setState({ preview: false });
              this.props.onElementSelected(undefined, undefined, undefined);
            }}
          >
            {this.files.map((file, i) => {
              let split = file.name.split(".");
              let filetype = file.type; // ? file.type : ((split && (split.length > 1)? split[split.length-1]:'application'));
              let isActive = file.id === this.props.idSelected;
              return (
                <Col
                  key={i}
                  className={"myFile myFileLibrary" + (file.hide ? " hidden" : "")}
                  xs={12}
                  sm={4}
                  md={2}
                  lg={2}
                >
                  {/* {isActive ? <Button className="deleteButton" onClick={(e)=>{
                                this.setState({ confirmDelete: true });
                                e.stopPropagation();}}>
                                <i className="material-icons">delete</i>
                            </Button> : null} */}
                  {/* {isActive ? <Button className="downloadButton" onClick={(e)=>{
                                download.action();}}>
                                <i className="material-icons">cloud_download</i>
                            </Button> : null} */}
                  {isActive && this.props.elementSelectedType !== "image" ? (
                    <Button
                      className="previewFileButton"
                      onClick={(e) => {
                        e.stopPropagation();
                        this.setState({ preview: true });
                      }}
                    >
                      {this.props.elementSelectedType === "audio" ? (
                        <i className="material-icons">volume_down</i>
                      ) : (
                        <i className="material-icons">remove_red_eye</i>
                      )}
                    </Button>
                  ) : null}
                  <Button
                    style={{
                      backgroundSize: "contain",
                      backgroundRepeat: "no-repeat",
                      backgroundImage: true /* filetype === 'image' */
                        ? "url(" + file.url + ")"
                        : "",
                    }}
                    onClick={(e) => {
                      this.props.onElementSelected(
                        file.name,
                        file.url,
                        "image" /* filetype*/,
                        file.id
                      );
                      e.stopPropagation();
                    }}
                    className={"myFileContent" + (isActive ? " active" : "")}
                  >
                    {
                      file.type === "image"
                        ? ""
                        : "" /* <i className="material-icons">{file.icon || "face"}</i>*/
                    }
                  </Button>
                  {/* <span className="ellipsis">{file.name}</span> */}
                </Col>
              );
            })}
          </Row>
          {this.state.confirmDelete ? (
            <Alert
              className="pageModal"
              show
              hasHeader
              title={
                <span>
                  <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
                    delete
                  </i>
                  {i18n.t("messages.confirm_delete_cv")}
                </span>
              }
              cancelButton
              acceptButtonText={i18n.t("messages.OK")}
              onClose={(bool) => {
                if (bool) {
                  this.props.onElementSelected(undefined, undefined, undefined);
                  this.props.deleteFileFromServer(
                    this.props.idSelected,
                    this.props.elementSelected,
                    (status) => {
                      if (!status) {
                        this.setState({ errorDeleteAlert: true });
                      }
                    }
                  );
                }
                this.setState({ confirmDelete: false });
              }}
            >
              <span> {i18n.t("FileModal.APIProviders.confirm_delete")} </span>
              <br />
            </Alert>
          ) : null}
          {empty ? <p className="empty">{i18n.t("FileModal.APIProviders.no_files")}</p> : null}
          {this.state.errorDeleteAlert ? (
            <Alert
              className="pageModal"
              show
              hasHeader
              acceptButtonText={i18n.t("messages.OK")}
              title={
                <span>
                  <i style={{ fontSize: "14px", marginRight: "5px" }} className="material-icons">
                    warning
                  </i>
                  {i18n.t("messages.error")}
                </span>
              }
              onClose={() => {
                this.setState({ errorDeleteAlert: false });
              }}
            >
              <span> {i18n.t("error.deleting")} </span>
              <br />
            </Alert>
          ) : null}
          <AppModal
            className="previewVideoModal"
            show={!!(this.state.preview && this.props.elementSelected)}
            onClose={() => this.setState({ preview: false })}
            title={i18n.t("Preview")}
          >
            {this.generatePreview()}
          </AppModal>
        </Container>
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.show !== this.props.show) {
      this.setState({ extensionFilter: nextProps.show });
    }
  }
  componentWillUpdate(nextProps, nextState) {
    if (
      nextProps.filesUploaded &&
      this.props.filesUploaded &&
      nextProps.filesUploaded.length !== this.props.filesUploaded.length
      /* || nextState.filter !== this.state.filter || nextState.extensionFilter !== this.state.extensionFilter*/
    ) {
      // this.props.onElementSelected( undefined, undefined, undefined);
    }
  }
  generatePreview() {
    let item = this.props.elementSelected;
    switch (this.props.elementSelectedType) {
      case "webapp":
      case "pdf":
      case "scormpackage":
        return (
          <iframe src={this.props.elementSelected} frameBorder="0" width={"100%"} height={"400"} />
        );
      case "image":
        return null;
      case "audio":
        return (
          <audio
            src={this.props.elementSelected}
            controls
            width={"100%"}
            height={"400"}
            style={{ width: "100%" }}
          />
        );
      case "video":
        return <video src={this.props.elementSelected} controls width={"100%"} height={"400"} />;
      case "swf":
        return (
          <embed src={this.props.elementSelected} wmode="opaque" width={"100%"} height={"400"} />
        );
      case "xml":
      case "csv":
      case "edi":
      case "vish":
        return <CodePreview source={this.props.elementSelected} />;
      default:
        return null;
    }
  }
}

CharactersComponent.propTypes = {
  /**
   * Filter that indicates what types of files are shown. "*" means all.
   */
  show: PropTypes.any,
  /**
   * Files uploaded to server
   */
  filesUploaded: PropTypes.any,
  /**
   * Identifier of element whose source is being changed (box/slide background). It can be empty
   */
  idSelected: PropTypes.any,
  /**
   * Selected Element type
   */
  elementSelectedType: PropTypes.any,
  /**
   * Element selected from files
   */
  elementSelected: PropTypes.any,
  /**
   * Function that is called when the user selects an element
   */
  onElementSelected: PropTypes.func.isRequired,
  /**
   * Function for deleting files from server
   */
  deleteFileFromServer: PropTypes.func,
};
